import { createMap } from "@omnia/shared/utils/array"
import { getMorganAttribute, getSoilUnitOption, getSoilUnitOptions, IGenericAnalysisAlloc, ILayerViewModel, ISoilAnalysis, ISoilAnalysisAlloc, soilColors, SoilUnit } from "../../../omnia"
import { IDataLayer, ISoilAnalysisLayerViewerFactory, LayerTypeId } from "../../../types"
import { createMapViewGroup } from "../group"
import { IViewerContext } from "../types"
import { AnalysisView } from "./analysis"

export function createSoilAnalysisGroup(ctxt: IViewerContext) {

    let { soilSvc, layers, viewManager } = ctxt

    const analysis = soilSvc.getSoilAnalyses()

    const layerType = soilSvc.getLayerType(LayerTypeId.SoilAnalysis)

    layers = layers.filter(l => l.TypeId == LayerTypeId.SoilAnalysis)

    let viewers = viewManager
        .getViewers(LayerTypeId.SoilAnalysis)
        .filter(v => v.appliesToType(layerType))
        .map(v => new StdAnalysisView(ctxt, analysis, layers, v))

    return createMapViewGroup("S", "Soil analysis", viewers)

}

export class StdAnalysisView extends AnalysisView<ISoilAnalysis> {

    constructor(
        ctxt: IViewerContext,
        analysis: ISoilAnalysis[],
        layers: IDataLayer[],
        layerViewer: ISoilAnalysisLayerViewerFactory,
        private readonly morgan = getMorganAttribute(layerViewer.key)) {

        super(ctxt, analysis, LayerTypeId.SoilAnalysis, layers, layerViewer, a => a.FirstYear)

        this.setupUnits()

    }

    protected getAnalysisId(a: ISoilAnalysis) {
        return a.SoilAnalysisId
    }

    protected checkZoneAllocation(alloc: IGenericAnalysisAlloc): boolean {
        const salloc = <ISoilAnalysisAlloc>alloc
        return (!!salloc.ZoneId) || (!!salloc.ZoneAlloc)
    }

    protected setupUnits() {

        const units = this.layerViewer.units

        if (typeof units === "string") {
            super.setupUnits([{ id: 0, label: units }], units)
        }
        else if (typeof units === "number") {
            const options = [getSoilUnitOption(units)].filter(a => !!a)
            super.setupUnits(options, this.layerViewer.units)
        }
        else if (typeof units === "function") {
            super.setupUnits(
                getSoilUnitOptions(),
                this.layerViewer.units
            )
        }

        this.updateColors()

    }

    protected setCurrentUnit(unit: SoilUnit) {
        super.setCurrentUnit(unit)
        this.ctxt.soilSvc.units.soil = unit
        this.updateColors()
    }


    protected updateColors() {

        const { morgan, currentUnit } = this

        if (!morgan) {
            return
        }

        switch (currentUnit) {

            case SoilUnit.Index:
            case SoilUnit.Ppm:
                {
                    const colors = soilColors.getSoilColors(this.key)
                    this.setupColors(colors)
                }
                break

            case SoilUnit.Morgan:
                {
                    const colors = soilColors.getMorganColors(this.morgan)
                    this.setupColors(colors)
                }
                break

        }

    }

}
